export default __webpack_public_path__ + "static/media/pracxel-logo.12288622.svg";